import { UserFactory, Keys } from './VodFactoryCreator';
import { VodDetail } from '@/entities/VodDetail';

// Return the base class as per keys value
export class VodService {
  public static GetEntityObjectByType(Type: number, vodDetail: VodDetail, entityId: number, sessionStartDate: Date, uploadUrl: string, acceptedVideoFileTypes: string, acceptedCaptionFileTypes: string, subModuleType: number) {
    return UserFactory.GetInstance(Type as Keys).GetValues(vodDetail,entityId,sessionStartDate,uploadUrl,acceptedVideoFileTypes,acceptedCaptionFileTypes,subModuleType);
  }
}
